import type { INamespaceContent } from '../../types';
import { getServices } from './services';
import { getFAQQuestions } from './faqQuestions';
import { getFAQDocuments } from './faqDocuments';
import { getClaimsContent } from './claims';

export const getContent = (): INamespaceContent => ({
  services: getServices(),
  faqQuestions: getFAQQuestions(),
  faqDocuments: getFAQDocuments(),
  claims: getClaimsContent(),
});
